<template>
  <footer class="bg-theme-footer text-theme-footer-text transition-colors duration-300 z-20 md:sticky md:bottom-0 mb-14 md:mb-0">
    <div class="container mx-auto px-4 md:px-10 py-4">

      <div class="grid grid-cols-2 md:grid-cols-4 gap-x-5 gap-y-3 mb-3">

        <!-- Account -->
        <div>
          <p class="text-[9px] font-semibold uppercase tracking-widest text-theme-footer-text/40 mb-1">Account</p>
          <ul class="space-y-1">
            <li><RouterLink to="/cart" class="footer-link">Cart</RouterLink></li>
            <li><RouterLink to="/profile?section=chats" class="footer-link">Messages</RouterLink></li>
            <li><RouterLink to="/new-profile/orders" class="footer-link">My Orders</RouterLink></li>
            <li><RouterLink to="/new-profile/items" class="footer-link">My Items</RouterLink></li>
          </ul>
        </div>

        <!-- Explore -->
        <div>
          <p class="text-[9px] font-semibold uppercase tracking-widest text-theme-footer-text/40 mb-1">Explore</p>
          <ul class="space-y-1">
            <li><RouterLink to="/about" class="footer-link">About Us</RouterLink></li>
            <li><RouterLink to="/faqs" class="footer-link">FAQ</RouterLink></li>
            <li><RouterLink to="/contact" class="footer-link">Contact</RouterLink></li>
          </ul>
        </div>

        <!-- Legal -->
        <div>
          <p class="text-[9px] font-semibold uppercase tracking-widest text-theme-footer-text/40 mb-1">Legal</p>
          <ul class="space-y-1">
            <li><RouterLink to="/privacy-cookie-notice" class="footer-link">Privacy Policy</RouterLink></li>
            <li><RouterLink to="/terms-conditions" class="footer-link">Terms &amp; Conditions</RouterLink></li>
          </ul>
        </div>

        <!-- Contact -->
        <div>
          <p class="text-[9px] font-semibold uppercase tracking-widest text-theme-footer-text/40 mb-1">Connect</p>
          <a
            v-if="companyInfoStore.companyInfo?.email"
            :href="'mailto:' + companyInfoStore.companyInfo?.email"
            class="footer-link block truncate"
          >{{ companyInfoStore.companyInfo?.email }}</a>
        </div>

      </div>

      <!-- Bottom bar -->
      <div class="flex flex-wrap items-center justify-between gap-2 mt-1">
        <p class="text-[10px] text-theme-footer-text/50">
          &copy; {{ currentYear }} <span class="text-secondary-500 font-medium">{{ companyInfoStore.companyInfo?.name || 'Usenlease' }}</span>. All rights reserved.
        </p>
        <div class="flex items-center gap-2">
          <a
            v-for="(link, key) in socialLinks"
            :key="key"
            :href="link || '#'"
            class="social-icon"
            :aria-label="key"
          ><i :class="'pi pi-' + key + ' text-sm'"></i></a>
        </div>
      </div>

    </div>
  </footer>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useCompanyInfoStore } from '@/store/company';

const companyInfoStore = useCompanyInfoStore();
const currentYear = ref(new Date().getFullYear());

const socialLinks = computed(() => ({
  facebook: companyInfoStore.companyInfo?.facebook_link,
  twitter:  companyInfoStore.companyInfo?.twitter_link,
  instagram: companyInfoStore.companyInfo?.instagram_link,
  linkedin: companyInfoStore.companyInfo?.linkedin_link,
}));
</script>

<style scoped>
.footer-link {
  font-size: 0.7rem;
  color: var(--color-footerText, #e0e0e0);
  opacity: 0.75;
  transition: opacity 0.15s ease, color 0.15s ease;
}
.footer-link:hover {
  opacity: 1;
  color: var(--color-secondary-500, #ffc107);
}

.social-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid var(--color-footerText, #e0e0e0);
  border-opacity: 0.2;
  color: var(--color-footerText, #e0e0e0);
  opacity: 0.6;
  transition: opacity 0.15s ease, color 0.15s ease, transform 0.15s ease;
}
.social-icon:hover {
  opacity: 1;
  color: var(--color-secondary-500, #ffc107);
  transform: translateY(-1px);
}
</style>
